// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ConstrainedImgBox-module__ui-ConstrainedImgBox--kQxtF {
  overflow: hidden;
  display: inline-block;
  position: relative;
}

.ConstrainedImgBox-module__ui-ConstrainedImgBox--kQxtF img {
  object-fit: cover;
}
`, "",{"version":3,"sources":["webpack://./../../packages/design-system/src/components/ConstrainedImgBox/ConstrainedImgBox.module.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB","sourcesContent":[".ui-ConstrainedImgBox {\n  overflow: hidden;\n  display: inline-block;\n  position: relative;\n}\n\n.ui-ConstrainedImgBox img {\n  object-fit: cover;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"ui-ConstrainedImgBox": `ConstrainedImgBox-module__ui-ConstrainedImgBox--kQxtF`
};
export default ___CSS_LOADER_EXPORT___;
